import { idtype } from "querypieces";

export default `
...on pageBuilder_item_BlockType {
	${idtype}
	richTextSimple
}
`